export default "__VITE_ASSET__DgejM55g__"